import {
  IAutoOrderQuantityWriteLog,
  IAutoOrderQuantityWriteLogInput,
} from '../models/auto-order-quantity-write-log';

/**
 * Builds a structured `setAOQuantities` log payload without item, price, or credential fields.
 */
export function buildAutoOrderQuantityWriteLog(
  input: IAutoOrderQuantityWriteLogInput,
): IAutoOrderQuantityWriteLog {
  const log: IAutoOrderQuantityWriteLog = {
    actionSource: input.actionSource,
    environment: input.environment,
    frontendVersion: input.frontendVersion || 'unknown',
    orderId: input.orderId,
    preparedItemsCount: input.preparedItemsCount,
    status: input.status,
    storeId: input.storeId,
    supplierId: input.supplierId,
    supplierName: input.supplierName || 'unknown',
    total: input.total,
    writeResult: input.writeResult,
  };

  if (input.errorMessage) {
    log.errorMessage = input.errorMessage;
  }

  return log;
}

/**
 * Extracts a safe error message from an unknown thrown value.
 */
export function getAutoOrderQuantityWriteErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  return String(error);
}
